<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>
      Click on any of the following to proceed...
    </p>
    <h3>Services</h3>
    <ul>
      <li> <a href="https://crisedgar.com/music"> <img alt="Music icon" src="./../assets/bx-headphone.svg"></a> </li>
      <li> <a href="https://crisedgar.com/git/"> <img alt="Source code icon" src="./../assets/bx-code.svg"></a> </li>
      <li> <a href="https://crisedgar.com/nextcloud"> <img alt="Cloud icon" src="./../assets/bxs-cloud.svg"></a> </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Services',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

img{
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 5px;
  width: 110%;
}
</style>
